/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { RecoveryBodyModel } from '../model/recoveryBodyModel';
import { RecoveryStateModel } from '../model/recoveryStateModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RecoveryService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [MOBILE] Gets recovery by body area
     * Returns the caller&#x27;s Upper, Push, Pull, Core and Lower readings and per-muscle loads, norms, readings, overload flags, sets and sessions for each local day from From to To, at most 31 days.
     * @param from 
     * @param to 
     * @param clientUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meRecoveryBodyGet(from?: string, to?: string, clientUid?: string, observe?: 'body', reportProgress?: boolean): Observable<RecoveryBodyModel>;
    public meRecoveryBodyGet(from?: string, to?: string, clientUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RecoveryBodyModel>>;
    public meRecoveryBodyGet(from?: string, to?: string, clientUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RecoveryBodyModel>>;
    public meRecoveryBodyGet(from?: string, to?: string, clientUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('From', <any>from);
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('To', <any>to);
        }
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RecoveryBodyModel>('get',`${this.basePath}/Me/Recovery/Body`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets recovery state
     * Returns the caller&#x27;s recovery state for the given local day, or today. Status distinguishes ready, updating, calculating and unavailable; the result payload arrives with the recovery model.
     * @param localDate 
     * @param clientUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meRecoveryGet(localDate?: string, clientUid?: string, observe?: 'body', reportProgress?: boolean): Observable<RecoveryStateModel>;
    public meRecoveryGet(localDate?: string, clientUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RecoveryStateModel>>;
    public meRecoveryGet(localDate?: string, clientUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RecoveryStateModel>>;
    public meRecoveryGet(localDate?: string, clientUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (localDate !== undefined && localDate !== null) {
            queryParameters = queryParameters.set('LocalDate', <any>localDate);
        }
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RecoveryStateModel>('get',`${this.basePath}/Me/Recovery`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets a client&#x27;s recovery by body area
     * Returns the specified client&#x27;s Upper, Push, Pull, Core and Lower readings and per-muscle loads, norms, readings, overload flags, sets and sessions for each local day from From to To, at most 31 days.
     * @param from 
     * @param to 
     * @param clientUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recoveryBodyGet(from?: string, to?: string, clientUid?: string, observe?: 'body', reportProgress?: boolean): Observable<RecoveryBodyModel>;
    public recoveryBodyGet(from?: string, to?: string, clientUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RecoveryBodyModel>>;
    public recoveryBodyGet(from?: string, to?: string, clientUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RecoveryBodyModel>>;
    public recoveryBodyGet(from?: string, to?: string, clientUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('From', <any>from);
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('To', <any>to);
        }
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RecoveryBodyModel>('get',`${this.basePath}/Recovery/Body`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets a client&#x27;s recovery state
     * Returns the specified client&#x27;s recovery state for the given local day, or today in the client&#x27;s zone: Ready, Updating, Calculating or Unavailable, with the result payload once one exists.
     * @param localDate 
     * @param clientUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recoveryGet(localDate?: string, clientUid?: string, observe?: 'body', reportProgress?: boolean): Observable<RecoveryStateModel>;
    public recoveryGet(localDate?: string, clientUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RecoveryStateModel>>;
    public recoveryGet(localDate?: string, clientUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RecoveryStateModel>>;
    public recoveryGet(localDate?: string, clientUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (localDate !== undefined && localDate !== null) {
            queryParameters = queryParameters.set('LocalDate', <any>localDate);
        }
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RecoveryStateModel>('get',`${this.basePath}/Recovery`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
